import type { BoundaryCoordinates } from '$lib/components/map/types';
import type { SupportedCountry } from '@viamichelin/business';

export const defaultMapBoundsByCountry: Record<SupportedCountry, BoundaryCoordinates> = {
	FR: [
		[-4.7954075, 42.3329616],
		[8.232452, 51.0895047],
	],
	BE: [
		[2.5453968, 49.4972655],
		[6.4079065, 51.5050807],
	],
	GB: [
		[-6.791374, 49.9536734],
		[1.768926, 58.707692],
	],
	ES: [
		[-9.3013602, 36.0002408],
		[3.3224642, 43.7903881],
	],
	PT: [
		[-9.816437, 36.7603059],
		[-6.1902091, 42.1542048],
	],
	IT: [
		[6.6266397, 37.9157694],
		[18.5203619, 47.0924248],
	],
	DE: [
		[5.8663566, 47.270127],
		[15.0418536, 54.9116626],
	],
	CH: [
		[5.955894, 45.8177919],
		[10.49238, 47.808381],
	],
	AT: [
		[9.530787, 46.372299],
		[17.160749, 49.020712],
	],
	IE: [
		[-10.4782739, 51.4475435],
		[-5.9988317, 55.3829431],
	],
	// Word wide bounds
	US: [
		[-179.64843, -70.02058],
		[151.875, 85.0207],
	],
	NL: [
		[3.2976616, 50.750449],
		[7.2275448, 53.5757042],
	],
};

export const MAX_FIT_ZOOM = 15; // going too close users can get lost

export const MAPLIBRE_RTL_TEXT_PLUGIN_URL
	= 'https://api.mapbox.com/mapbox-gl-js/plugins/mapbox-gl-rtl-text/v0.3.0/mapbox-gl-rtl-text.js';
